import React from 'react';
import { useRecordContext } from 'react-admin';
import Chip from '@mui/material/Chip';

const categoryConfig = {
    lab: { label: 'Lab', color: '#9c27b0' },
    marketing: { label: 'Marketing', color: '#e91e63' },
    infra: { label: 'Infra', color: '#607d8b' },
    sales: { label: 'Sales', color: '#2196f3' },
    people: { label: 'People', color: '#f44336' },
    strategy: { label: 'Strategy', color: '#ff9800' }
};

const CategoryField = () => {
    const record = useRecordContext();
    if (!record || !record.category) return null;

    const config = categoryConfig[record.category] || { label: record.category, color: '#999' };

    return (
        <Chip
            label={config.label}
            size="small"
            sx={{ backgroundColor: config.color, color: '#fff' }}
        />
    );
};

export default CategoryField;
